import CardHeader from '@/components/Card/CardHeader';
import { modalStyle } from '@/views/Clients/Claim';
import { Box, Modal } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import { StatusHistoryHeaderRow, StatusHistoryRow } from './StatusHistoryRow';
import { useTranslation } from 'react-i18next';

export const StatusHistoryModal = ({
  open,
  onClose,
  role,
  statusHistory,
  onRetryPullingAch,
  refund,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onClose={onClose}
      scroll='body'
      aria-labelledby='form-dialog-title'
      className='otp-dialog'
      style={{ overflow: 'visible', width: '80vw' }}>
      <Box
        sx={{ ...modalStyle, maxWidth: '80vw' }}
        style={{ maxHeight: '90vh', width: '80vw', overflow: 'visible' }}>
        <CardHeader style={{ transform: 'translateY(-50%)' }} color='primary'>
          <h4>{t('statusHistory.title')}</h4>
        </CardHeader>

        <div
          style={{
            width: '100%',
            padding: '0 30px 50px 30px',
            overflow: 'scroll',
          }}>
          <div>
            {refund?.tags && refund.tags.length > 0 && (
              <div
                style={{
                  marginBottom: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '8px',
                }}>
                <h6 style={{ margin: '0', fontSize: '14px' }}>
                  {t('statusHistory.tags')}:
                </h6>
                {refund.tags.map((tag, index) => (
                  <span
                    key={index}
                    style={{
                      backgroundColor: '#e3f2fd',
                      color: '#1976d2',
                      padding: '4px 12px',
                      borderRadius: '16px',
                      fontSize: '12px',
                      fontWeight: '500',
                      border: '1px solid #bbdefb',
                    }}>
                    {t(`statusHistory.tag-${tag}`, { defaultValue: tag })}
                  </span>
                ))}
                {refund?.filename && (
                  <span
                    style={{
                      margin: '0',
                      fontSize: '14px',
                      marginLeft: '16px',
                    }}>
                    {t('statusHistory.file')}: {refund.filename}
                  </span>
                )}
                {refund?.created_by && (
                  <span
                    style={{
                      margin: '0',
                      fontSize: '14px',
                      marginLeft: '16px',
                    }}>
                    {t('statusHistory.createdBy')}: {refund.created_by}
                  </span>
                )}
              </div>
            )}
          </div>

          <Table>
            <TableHead>
              <StatusHistoryHeaderRow role={role} />
            </TableHead>
            <TableBody>
              {statusHistory &&
                statusHistory.map((obj, index) => (
                  <StatusHistoryRow
                    key={index}
                    obj={obj}
                    role={role}
                    onRetryPullingAch={onRetryPullingAch}
                  />
                ))}
            </TableBody>
          </Table>
        </div>
      </Box>
    </Modal>
  );
};
